import { ChangeDetectorRef, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { QuickSearchBaseComponent } from '@shared/components/header/quick-access/quick-search-base.component';
import {
  GoogleAnalyticsAction,
  GoogleAnalyticsCategory,
  GoogleAnalyticsLabel,
} from '@shared/google-analytics/google-analytics.model';
import { GoogleAnalyticsService } from '@shared/google-analytics/google-analytics.service';
import { TopNotificationService } from '@shared/services/notification/top-notification.service';
import { takeUntil } from 'rxjs/operators';
import { SearchCategoryEnum, SearchResult } from '../data/quick-access.model';
import { QuickAccessService } from '../services/quick-access.service';

@Component({
  selector: 'eop-quick-access',
  templateUrl: './quick-access.component.html',
  styleUrls: ['./quick-access.component.scss'],
  standalone: false,
})
export class QuickAccessComponent extends QuickSearchBaseComponent {
  protected quickAccessService: QuickAccessService;
  protected topNotificationService: TopNotificationService;
  protected cdr: ChangeDetectorRef;
  private readonly router = inject(Router);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  @ViewChild('searchInput') searchInputElement: ElementRef<HTMLInputElement>;

  constructor() {
    const quickAccessService = inject(QuickAccessService);
    const topNotificationService = inject(TopNotificationService);
    const cdr = inject(ChangeDetectorRef);

    super(quickAccessService, topNotificationService, cdr);

    this.quickAccessService = quickAccessService;
    this.topNotificationService = topNotificationService;
    this.cdr = cdr;
  }

  originPopover(): ElementRef<HTMLElement> {
    return this.searchInputElement;
  }

  searchInput(): ElementRef<HTMLInputElement> {
    return this.searchInputElement;
  }

  selected(element: SearchResult) {
    this.setPopoverVisibility(false);
    this.searchInput().nativeElement.blur();

    this.googleAnalyticsService.sendEvent(
      GoogleAnalyticsCategory.QUICK_SEARCH,
      GoogleAnalyticsAction.SEARCH,
      element.category === SearchCategoryEnum.CHARGINGSTATION
        ? GoogleAnalyticsLabel.CHARGING_STATION
        : GoogleAnalyticsLabel.CHARGE_PORT
    );

    this.router.navigate(['/operate/chargingInfrastructureDetail'], {
      queryParams: {
        uuid: element.stationUuid,
        ...(element.category === SearchCategoryEnum.CHARGEPOINT && {
          chargePort: element.value,
        }),
      },
    });
  }

  protected resetSearchInputOnRouteChange(): void {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.searchInput().nativeElement.value = '';
      this.minCharsReached = false;
    });
  }
}
